import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const InputDate = ({ field, value, handleChange, disabled }) => {
  return (
    <S.Wrapper>
      <p>{field.label}</p>
      <input
        type={field.type}
        name={field.name}
        value={value}
        onChange={(e) => handleChange(field.name, e.target.value)}
        disabled={disabled}
      />
    </S.Wrapper>
  );
};

InputDate.propTypes = {
  field: PropTypes.object,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
};
